import gql from 'graphql-tag';

export default gql`
    mutation ValidateResetPasswordToken($token: String!) {
        auth {
            validateResetPasswordToken(token: $token)
        }
    }
`;
